import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { MICROSOFT_WEATHER_GDD } from '../constants/featureFlags';
import { FeatureFlagKey } from '../types';

const getConfig = (state: AppState) => state.feature.userConfigFeatures;
const getFeatureFlagKey = (_state: AppState, { key }: { key: FeatureFlagKey }) => key;

export const getFeatureValue = createSelector([
  getConfig,
  getFeatureFlagKey
], (config, key) => Boolean(config[key]?.value));

export const getMicrosoftGDDSelector = createSelector(
  [getConfig],
  (config) => Boolean(config[MICROSOFT_WEATHER_GDD]?.value)
)
